import { useState, useEffect, Suspense, lazy } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";

const DeepResearchPage = lazy(() => import("./DeepResearchPage"));

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Ecosystem Research — Deep Research (el pipeline Dealflow B2B + Dealflow Airtable
 * se movieron a /partners como pestaña "Dealflow" el 2026-08-27 — un único flujo de
 * negocio junto al censo de partners, en vez de 2 pantallas separadas para lo mismo).
 */
export default function ObservatorioShell() {
  const [ecosystemTotal, setEcosystemTotal] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");
    if (!token) return;
    axios.get(`${API}/partners/unified`, { headers: { Authorization: `Bearer ${token}` }, params: { page: 1, page_size: 1 } })
      .then(r => setEcosystemTotal(r.data?.total ?? null))
      .catch(() => {});
  }, []);

  return (
    <div className="space-y-4" data-testid="ecosystem-research-shell">
      <div className="px-6 pt-6 border-b pb-4">
        <div className="text-xs uppercase tracking-widest text-emerald-700 font-semibold mb-1">Innovation OS · Observatorio + Research</div>
        <h1 className="text-2xl font-bold tracking-tight">Deep Research</h1>
        <p className="text-sm text-muted-foreground mt-1" data-testid="ecosystem-total-note">
          Investigación profunda de mercado/tecnología. El pipeline <strong>Dealflow</strong> se gestiona ahora en <strong>Partners</strong>{ecosystemTotal != null ? ` (${ecosystemTotal} entidades)` : ""}.
        </p>
      </div>

      <Suspense fallback={<div className="p-12 flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-emerald-600" /></div>}>
        <DeepResearchPage />
      </Suspense>
    </div>
  );
}
